import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('nrpc_access_token');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('nrpc_access_token');
        void router.navigateByUrl('/login');
      }

      return throwError(() => error);
    }),
  );
};
